import { render, staticRenderFns } from "./index.vue?vue&type=template&id=58d74bb6&scoped=true&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "./index.vue?vue&type=style&index=0&id=58d74bb6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58d74bb6",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {AccountFranchisorMembership: require('/home/circleci/repo/components/account-franchisor/AccountFranchisorMembership.vue').default,AccountFranchisorLayout: require('/home/circleci/repo/components/account-franchisor/AccountFranchisorLayout.vue').default})
